import { render, staticRenderFns } from "./OrderIssuesLog.vue?vue&type=template&id=486592e6&scoped=true"
import script from "./OrderIssuesLog.vue?vue&type=script&lang=js"
export * from "./OrderIssuesLog.vue?vue&type=script&lang=js"
import style0 from "./OrderIssuesLog.vue?vue&type=style&index=0&id=486592e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486592e6",
  null
  
)

export default component.exports